<template>
    <section-container
        title="Últimas viagens deste veículo"
        icon="route"
        css-class="mt-4"
    >
        <div class="table-responsive">
            <table class="table table-hover">
                <thead class="thead-light">
                <tr>
                    <th scope="col">Condutor</th>
                    <th scope="col">Retirado em</th>
                    <th scope="col">Entregue em</th>
                    <th
                        scope="col"
                        width="100"
                    >Ações
                    </th>
                </tr>
                </thead>
                <tbody v-if="vehicleData.last_trips && vehicleData.last_trips.length > 0">
                <tr
                    v-for="trip in vehicleData.last_trips"
                    :key="trip.id"
                >
                    <td>
                        <div class="user-cell">
                            <i class="fas fa-user-circle text-primary mr-2"></i>
                            {{ trip.user ? trip.user.name : 'N/A' }}
                        </div>
                    </td>
                    <td>
                        <div class="date-cell">
                            <i class="fas fa-calendar-check text-success mr-2"></i>
                            {{ trip.checkout ? trip.checkout.retreat_at : 'N/A' }}
                        </div>
                    </td>
                    <td>
                        <div class="date-cell">
                            <i class="fas fa-calendar-times text-danger mr-2"></i>
                            {{ trip.checkin ? trip.checkin.devoluted_at : 'N/A' }}
                        </div>
                    </td>
                    <td>
                        <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            @click="$emit('open-trip-details', trip.id)"
                            title="Consultar informações"
                        >
                            <i class="fas fa-info-circle"></i>
                        </button>
                    </td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                    <td
                        colspan="4"
                        class="text-center py-4"
                    >
                        <div class="empty-state">
                            <i class="fas fa-car text-muted mb-3"></i>
                            <p>Este veículo ainda não realizou viagens.</p>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div
            v-if="vehicleData.last_trips && vehicleData.last_trips.length > 0"
            class="pagination-container"
        >
            <pagination
                v-model="currentPage"
                :records="totalTrips"
                :options="paginationOptions"
                :per-page="tripsPerPage"
                @paginate="$emit('load-page', currentPage)"
            />
        </div>
    </section-container>
</template>
<script>
import SectionContainer from "../Checklist/SectionContainer.vue";
import {Pagination} from 'vue-pagination-2';

export default {
    name: "LastTripsTable",
    components: {
        SectionContainer,
        Pagination,
    },
    props: {
        vehicleData: {
            type: Object,
            default: () => ({})
        },
        totalTrips: {
            type: Number,
            default: () => 0
        }
    },
    data() {
        return {
            currentPage: 0,
            tripsPerPage: 5,
            paginationOptions: {
                texts: {
                    count: "Mostrando {from} de {to} até {count} de registros",
                },
                page: 1,
                chunk: 4,
                chunksNavigation: "fixed",
            }
        };
    },
}
</script>



// WEBPACK FOOTER //
// src/components/Modals/Components/LastTripsTable.vue